import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Button, Input, Textarea } from '@baseV2'
import { strings } from '@constants'
import { FaqItemWrapper } from '../styles'
import { toggleDrawer } from '@data/state/action/root'

const deriveFormState = () => {
	let _state = {
		question: {
			id: 'faq-question',
			label: strings('question'),
			placeholder: strings('enter', 'question'),
			value: '',
			required: true,
		},
		answer: {
			id: 'faq-answer',
			label: strings('answer'),
			placeholder: strings('enter', 'answer'),
		},
	}
	return _state
}

const AddFaq = ({ CreateFaqItems }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))

	const updateState = (key) => (value) => {
		setFormState((_s) => ({ ..._s, [key]: { ..._s[key], value } }))
	}

	const disabled = useMemo(() => {
		if (!formState.answer?.value || !formState.question?.value) {
			return true
		}
		return false
	}, [formState])

	const addFaqHandler = () => {
		const _faq = {
			question: formState?.question?.value,
			created_by: loggedInUser?.user_id,
			created_at: new Date().getTime(),
			answer: formState?.answer?.value,
		}
		CreateFaqItems(_faq)
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<FaqItemWrapper>
					<Input
						id={formState.question?.id}
						type='text'
						label={formState.question?.label}
						placeholder={formState.question?.placeholder}
						value={formState.question?.value}
						required={formState.question?.required}
						onChange={(e) => updateState('question')(e.target.value)}
					/>
				</FaqItemWrapper>
				<FaqItemWrapper>
					<Textarea
						id='quote-summary'
						label={formState.answer?.label}
						type='text'
						rows={6}
						placeholder={formState.answer?.placeholder}
						value={formState.answer?.value}
						onChange={(e) => updateState('answer')(e.target.value)}
						maxlength={10}
					/>
				</FaqItemWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button size='base' onClick={addFaqHandler} disabled={disabled}>
					{strings('add')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddFaq
